export const tagRoutes = {
	tagIndex: '/tags',
	tagHistory: (id?: string) => `/tags/${id ?? ':id'}/history`
} as const
